<template>
  <simple-modal 
    ref    = "zoneselect"
    :title = "$I18n('zone')"
    :large = "true"
    :right = "false"
    @submit= "submit"
  >
    <div slot="body" style="max-height: 80vh;overflow: auto;">
      <div v-for="letter in letterArray" :key="letter" class="md-layout" style="margin: 10px 0;"
        v-show="countryArray.filter(i => lang === 'zh' ?i.cn_sort === letter :i.en_sort === letter).length > 0">
        <!-- 字母 -->
        <div class="md-layout-item md-size-5" style="padding-top:10px; font-size: 16p;font-weight: 500;color: rgb(178,178,178);">{{letter}}</div>
        <!-- 选项 -->
        <div class="md-layout-item md-size-95 md-layout">
          <div @click="() => selectZone(item.code, item)" style="text-align: left;" v-for="item in countryArray.filter(i => lang === 'zh' ?i.cn_sort === letter :i.en_sort === letter)" :key="item.code" class="click-box md-layout-item md-size-25"
          >
            <div :class="{'selected': selectedCode.includes(item.code)}">{{lang === 'zh' ?item.cn_name :item.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </simple-modal>
</template>
<script>  
import {countryArray, letterArray} from "@/common/continent.js";
export default {
  name: "zone-select-mult-modal",
  data() {
    return {
      selected: [],
      lang : this.$router.history.current.query.lang,
      countryArray,
      letterArray,
    }
  },
  computed:{
    selectedCode(){
      return this.selected.map(i => i.code)
    },
  },
  methods: {
    open(val){
      if(val && val.length > 0){
        this.selected = this.countryArray.filter(i => val.includes(i.code));
      } else {
        this.selected = []
      }
      this.$refs.zoneselect.open();
    },
    close(){
      this.$refs.zoneselect.close();
    },
    submit(){
      this.$emit("select", this.selectedCode, this.selected);
      this.$refs.zoneselect.close();
    },
    selectZone(code, item){
      if(this.selectedCode.includes(code)){
        this.selected = this.selected.filter(i => i.code !== code)
      } else {
        this.selected = [...this.selected, item]
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .click-box{
    color: #000000;
    font-family: "宋体";
    // color: rgb(39, 46, 59);
    font-size: 14px;
    margin-top   : 5px;
    margin-bottom: 5px;
    padding: 5px;
    cursor :pointer;
    display:inline-block;
  }
  .click-box>div{
    display: inline-block;
    border-radius: 4px;
    padding: 0 8px;
}
  .click-box .selected{
    background: #00bcd440;
    font-weight: 600;
    color: #00bcd4;
  }
  .click-box:hover{
    background: #eeeeee;
  }
</style>